export default __webpack_public_path__ + "src/assets/icn-experience.a98843adf48c8109aeb2452ecfbe6b80.svg";